import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">Authentic Kerala Ayurvedic Therapy</div>
          <h1 className="hero-title">
            <span className="title-main">AURA</span>
            <span className="title-sub">Ayurveda & Wellness</span>
          </h1>
          <p className="hero-subtitle">Kerala Ayurvedic Massage Therapy Available</p>
          <p className="hero-description">
            Experience authentic Kerala Ayurvedic massage therapy with natural herbal oils. 
            Traditional healing for stress relief, detoxification, and deep relaxation.
          </p>
          <div className="hero-buttons">
            <a href="tel:+919876543210" className="cta-button primary">Call to Book</a>
            <Link to="/services" className="cta-button secondary">View Services</Link>
          </div>
          <p className="booking-note">Booking Available via Phone & WhatsApp • Advance Appointment Recommended</p>
        </div>
        <div className="hero-scroll-indicator">
          <span>Scroll to Explore</span>
          <div className="scroll-arrow">↓</div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-box">
            <div className="stat-number">10+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">50K+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">25+</div>
            <div className="stat-label">Expert Therapists</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">100%</div>
            <div className="stat-label">Natural Herbal Oils</div>
          </div>
        </div>
      </section>

      {/* Primary Services - Ayurveda */}
      <section className="services-highlight">
        <div className="section-header">
          <span className="section-badge">Our Specialization</span>
          <h2 className="section-title">Kerala Ayurvedic Massage Therapy</h2>
          <p className="section-subtitle">
            Authentic traditional body massage treatments using pure natural herbal oils for holistic healing
          </p>
        </div>
        <div className="services-grid">
          <div className="service-card featured">
            <div className="service-icon-wrapper">
              <div className="service-icon">🌿</div>
            </div>
            <h3>Ayurvedic Massage</h3>
            <p>Traditional Kerala massage therapy with warm herbal oils for complete body rejuvenation and stress relief</p>
            <Link to="/services" className="service-link">Learn More →</Link>
          </div>
          <div className="service-card featured">
            <div className="service-icon-wrapper">
              <div className="service-icon">💆</div>
            </div>
            <h3>Detoxification Therapy</h3>
            <p>Deep cleansing treatments using natural herbs to eliminate toxins and restore body balance</p>
            <Link to="/services" className="service-link">Learn More →</Link>
          </div>
          <div className="service-card featured">
            <div className="service-icon-wrapper">
              <div className="service-icon">🧘</div>
            </div>
            <h3>Stress Relief Treatment</h3>
            <p>Specialized massage techniques for deep relaxation, mental clarity, and emotional well-being</p>
            <Link to="/services" className="service-link">Learn More →</Link>
          </div>
          <div className="service-card featured">
            <div className="service-icon-wrapper">
              <div className="service-icon">✨</div>
            </div>
            <h3>Holistic Healing</h3>
            <p>Complete wellness programs combining ancient Ayurvedic wisdom with modern therapeutic practices</p>
            <Link to="/services" className="service-link">Learn More →</Link>
          </div>
        </div>
      </section>

      {/* Secondary Services - Salon */}
      <section className="secondary-services">
        <div className="section-header">
          <span className="section-badge">Additional Services</span>
          <h2 className="section-title">Unisex Salon Services</h2>
          <p className="section-subtitle">
            Professional hair and beauty services for men and women
          </p>
        </div>
        <div className="salon-services-grid">
          <div className="salon-service-item">
            <div className="salon-icon">✂️</div>
            <h4>Haircuts</h4>
            <p>Men & Women</p>
          </div>
          <div className="salon-service-item">
            <div className="salon-icon">�</div>
            <h4>Hair Coloring</h4>
            <p>Premium Products</p>
          </div>
          <div className="salon-service-item">
            <div className="salon-icon">💇</div>
            <h4>Hair Styling</h4>
            <p>Expert Stylists</p>
          </div>
          <div className="salon-service-item">
            <div className="salon-icon">💅</div>
            <h4>Beauty Services</h4>
            <p>Complete Care</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-header">
          <span className="section-badge light">Why AURA</span>
          <h2 className="section-title">Why Choose Us</h2>
          <p className="section-subtitle">
            Experience authentic Ayurvedic healing with certified therapists and pure natural ingredients
          </p>
        </div>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">�</div>
            </div>
            <h3>100% Natural Herbal Oils</h3>
            <p>Pure, authentic Kerala herbal oils prepared using traditional methods for maximum therapeutic benefits</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">👨‍⚕️</div>
            </div>
            <h3>Certified Therapists</h3>
            <p>Trained professionals with expertise in traditional Kerala Ayurvedic massage techniques</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">🏛️</div>
            </div>
            <h3>Traditional Methods</h3>
            <p>Authentic Kerala Ayurvedic practices passed down through generations for holistic healing</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">💯</div>
            </div>
            <h3>Hygiene Standards</h3>
            <p>Strict sanitization protocols and premium facilities ensuring your safety and comfort</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">🎯</div>
            </div>
            <h3>Personalized Treatment</h3>
            <p>Customized therapy plans tailored to your specific health needs and wellness goals</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon-box">
              <div className="feature-icon">⭐</div>
            </div>
            <h3>Premium Experience</h3>
            <p>Luxury ambiance with serene environment designed for complete relaxation and rejuvenation</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-header">
          <span className="section-badge">Testimonials</span>
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">
            Real experiences from clients who have benefited from our Ayurvedic treatments
          </p>
        </div>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">
              "The Kerala Ayurvedic massage was incredible! The therapists are highly skilled and the herbal oils 
              used are authentic. I felt completely relaxed and rejuvenated. Highly recommended!"
            </p>
            <div className="testimonial-author-section">
              <div className="author-avatar">P</div>
              <div>
                <p className="testimonial-author">Priya Sharma</p>
                <p className="testimonial-role">Wellness Client</p>
              </div>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">
              "Best Ayurvedic center in town! The detoxification therapy helped me immensely with stress relief. 
              The natural approach and professional service make AURA stand out."
            </p>
            <div className="testimonial-author-section">
              <div className="author-avatar">R</div>
              <div>
                <p className="testimonial-author">Rahul Verma</p>
                <p className="testimonial-role">Regular Client</p>
              </div>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">
              "Authentic Kerala massage with traditional techniques. The therapists are knowledgeable and caring. 
              The entire experience was therapeutic and healing. Worth every visit!"
            </p>
            <div className="testimonial-author-section">
              <div className="author-avatar">A</div>
              <div>
                <p className="testimonial-author">Anjali Mehta</p>
                <p className="testimonial-role">Ayurveda Client</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Experience Authentic Ayurvedic Healing</h2>
          <p>Book your Kerala Ayurvedic massage therapy session today</p>
          <p className="booking-info">Booking Available via Phone & WhatsApp • Advance Appointment Recommended</p>
          <div className="cta-buttons">
            <a href="tel:+919876543210" className="cta-button primary">Call Now</a>
            <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="cta-button secondary">WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
